// extracted by mini-css-extract-plugin
module.exports = {"default":"ButtonGhost_default__B6j3V","fullWidth":"ButtonGhost_fullWidth__xnnvb"};